/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "Calendário Budista",
          "chinese": "Calendário Chinês",
          "coptic": "Calendário Copta",
          "dangi": "Calendário Dangi",
          "ethiopic": "Calendário Etíope",
          "ethiopic-amete-alem": "Calendário Amete Alem da Etiópia",
          "gregorian": "Calendário Gregoriano",
          "hebrew": "Calendário Hebraico",
          "indian": "Calendário Nacional Indiano",
          "islamic": "Calendário Islâmico",
          "islamic-civil": "Calendário Civil Islâmico",
          "islamic-umalqura": "Calendário Islâmico (Umm al-Qura)",
          "iso8601": "Calendário ISO-8601",
          "japanese": "Calendário Japonês",
          "persian": "Calendário Persa",
          "roc": "Calendário da República da China"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "Peseta de Andorra",
          "AED": "Dirham dos Emirados Árabes Unidos",
          "AFA": "Afegane (1927–2002)",
          "AFN": "Afegane afegão",
          "ALK": "Lek Albanês (1946–1965)",
          "ALL": "Lek albanês",
          "AMD": "Dram armênio",
          "ANG": "Florim das Antilhas Holandesas",
          "AOA": "Kwanza angolano",
          "AOK": "Cuanza angolano (1977–1990)",
          "AON": "Novo cuanza angolano (1990–2000)",
          "AOR": "Cuanza angolano reajustado (1995–1999)",
          "ARA": "Austral argentino",
          "ARL": "Peso lei argentino (1970–1983)",
          "ARM": "Peso argentino (1881–1970)",
          "ARP": "Peso argentino (1983–1985)",
          "ARS": "Peso argentino",
          "ATS": "Xelim austríaco",
          "AUD": "Dólar australiano",
          "AWG": "Florim arubano",
          "AZM": "Manat azerbaijano (1993–2006)",
          "AZN": "Manat azeri",
          "BAD": "Dinar da Bósnia-Herzegovina (1992–1994)",
          "BAM": "Marco conversível da Bósnia e Herzegovina",
          "BAN": "Novo dinar da Bósnia-Herzegovina (1994–1997)",
          "BBD": "Dólar barbadense",
          "BDT": "Taka bengali",
          "BEC": "Franco belga (conversível)",
          "BEF": "Franco belga",
          "BEL": "Franco belga (financeiro)",
          "BGL": "Lev forte búlgaro",
          "BGM": "Lev socialista búlgaro",
          "BGN": "Lev búlgaro",
          "BGO": "Lev búlgaro (1879–1952)",
          "BHD": "Dinar bareinita",
          "BIF": "Franco burundiano",
          "BMD": "Dólar bermudense",
          "BND": "Dólar bruneano",
          "BOB": "Boliviano da Bolívia",
          "BOL": "Boliviano (1863–1963)",
          "BOP": "Peso boliviano",
          "BOV": "Mvdol boliviano",
          "BRB": "Cruzeiro novo brasileiro (1967–1986)",
          "BRC": "Cruzado brasileiro (1986–1989)",
          "BRE": "Cruzeiro brasileiro (1990–1993)",
          "BRL": "Real brasileiro",
          "BRN": "Cruzado novo brasileiro (1989–1990)",
          "BRR": "Cruzeiro brasileiro (1993–1994)",
          "BRZ": "Cruzeiro brasileiro (1942–1967)",
          "BSD": "Dólar bahamense",
          "BTN": "Ngultrum butanês",
          "BUK": "Kyat birmanês",
          "BWP": "Pula botsuanesa",
          "BYB": "Rublo novo bielo-russo (1994–1999)",
          "BYN": "Rublo bielorrusso",
          "BYR": "Rublo bielorrusso (2000–2016)",
          "BZD": "Dólar belizenho",
          "CAD": "Dólar canadense",
          "CDF": "Franco congolês",
          "CHE": "Euro WIR",
          "CHF": "Franco suíço",
          "CHW": "Franco WIR",
          "CLE": "Escudo chileno",
          "CLF": "Unidades de Fomento chilenas",
          "CLP": "Peso chileno",
          "CNH": "Yuan chinês (offshore)",
          "CNX": "Dólar do Banco Popular da China",
          "CNY": "Yuan chinês",
          "COP": "Peso colombiano",
          "COU": "Unidade de Valor Real",
          "CRC": "Colón costarriquenho",
          "CSD": "Dinar sérvio (2002–2006)",
          "CSK": "Coroa Forte checoslovaca",
          "CUC": "Peso cubano conversível",
          "CUP": "Peso cubano",
          "CVE": "Escudo cabo-verdiano",
          "CYP": "Libra cipriota",
          "CZK": "Coroa tcheca",
          "DDM": "Ostmark da Alemanha Oriental",
          "DEM": "Marco alemão",
          "DJF": "Franco djiboutiano",
          "DKK": "Coroa dinamarquesa",
          "DOP": "Peso dominicano",
          "DZD": "Dinar argelino",
          "ECS": "Sucre equatoriano",
          "ECV": "Unidade de Valor Constante (UVC) do Equador",
          "EEK": "Coroa estoniana",
          "EGP": "Libra egípcia",
          "ERN": "Nakfa da Eritreia",
          "ESA": "Peseta espanhola (conta A)",
          "ESB": "Peseta espanhola (conta conversível)",
          "ESP": "Peseta espanhola",
          "ETB": "Birr etíope",
          "EUR": "Euro",
          "FIM": "Marca finlandesa",
          "FJD": "Dólar fijiano",
          "FKP": "Libra malvinense",
          "FRF": "Franco francês",
          "GBP": "Libra esterlina",
          "GEK": "Cupom Lari georgiano",
          "GEL": "Lari georgiano",
          "GHC": "Cedi de Gana (1979–2007)",
          "GHS": "Cedi ganês",
          "GIP": "Libra de Gibraltar",
          "GMD": "Dalasi gambiano",
          "GNF": "Franco guineano",
          "GNS": "Syli da Guiné",
          "GQE": "Ekwele da Guiné Equatorial",
          "GRD": "Dracma grego",
          "GTQ": "Quetzal guatemalteco",
          "GWE": "Escudo da Guiné Portuguesa",
          "GWP": "Peso da Guiné-Bissau",
          "GYD": "Dólar guianense",
          "HKD": "Dólar de Hong Kong",
          "HNL": "Lempira hondurenha",
          "HRD": "Dinar croata",
          "HRK": "Kuna croata",
          "HTG": "Gourde haitiano",
          "HUF": "Florim húngaro",
          "IDR": "Rupia indonésia",
          "IEP": "Libra irlandesa",
          "ILP": "Libra israelita",
          "ILR": "Sheqel antigo israelita",
          "ILS": "Novo shekel israelense",
          "INR": "Rupia indiana",
          "IQD": "Dinar iraquiano",
          "IRR": "Rial iraniano",
          "ISJ": "Coroa antiga islandesa",
          "ISK": "Coroa islandesa",
          "ITL": "Lira italiana",
          "JMD": "Dólar jamaicano",
          "JOD": "Dinar jordaniano",
          "JPY": "Iene japonês",
          "KES": "Xelim queniano",
          "KGS": "Som quirguiz",
          "KHR": "Riel cambojano",
          "KMF": "Franco comoriano",
          "KPW": "Won norte-coreano",
          "KRH": "Hwan da Coreia do Sul (1953–1962)",
          "KRO": "Won da Coreia do Sul (1945–1953)",
          "KRW": "Won sul-coreano",
          "KWD": "Dinar kuwaitiano",
          "KYD": "Dólar das Ilhas Cayman",
          "KZT": "Tenge cazaque",
          "LAK": "Kip laosiano",
          "LBP": "Libra libanesa",
          "LKR": "Rupia cingalesa",
          "LRD": "Dólar liberiano",
          "LSL": "Loti lesotiano",
          "LTL": "Litas lituano",
          "LTT": "Talonas lituano",
          "LUC": "Franco conversível de Luxemburgo",
          "LUF": "Franco luxemburguês",
          "LUL": "Franco financeiro de Luxemburgo",
          "LVL": "Lats letão",
          "LVR": "Rublo letão",
          "LYD": "Dinar líbio",
          "MAD": "Dirham marroquino",
          "MAF": "Franco marroquino",
          "MCF": "Franco monegasco",
          "MDC": "Cupon moldávio",
          "MDL": "Leu moldávio",
          "MGA": "Ariary malgaxe",
          "MGF": "Franco de Madagascar",
          "MKD": "Dinar macedônio",
          "MKN": "Dinar macedônio (1992–1993)",
          "MLF": "Franco de Mali",
          "MMK": "Quiate mianmarense",
          "MNT": "Tugrik mongol",
          "MOP": "Pataca macaense",
          "MRO": "Ouguiya mauritana (1973–2017)",
          "MRU": "Ouguiya mauritana",
          "MTL": "Lira maltesa",
          "MTP": "Libra maltesa",
          "MUR": "Rupia mauriciana",
          "MVR": "Rupia maldivana",
          "MWK": "Kwacha malauiana",
          "MXN": "Peso mexicano",
          "MXP": "Peso Prata mexicano (1861–1992)",
          "MXV": "Unidade Mexicana de Investimento (UDI)",
          "MYR": "Ringgit malaio",
          "MZE": "Escudo de Moçambique",
          "MZM": "Metical de Moçambique (1980–2006)",
          "MZN": "Metical moçambicano",
          "NAD": "Dólar namibiano",
          "NGN": "Naira nigeriana",
          "NIC": "Córdoba nicaraguense (1988–1991)",
          "NIO": "Córdoba nicaraguense",
          "NLG": "Florim holandês",
          "NOK": "Coroa norueguesa",
          "NPR": "Rupia nepalesa",
          "NZD": "Dólar neozelandês",
          "OMR": "Rial omanense",
          "PAB": "Balboa panamenho",
          "PEI": "Inti peruano",
          "PEN": "Novo sol peruano",
          "PES": "Sol peruano (1863–1965)",
          "PGK": "Kina papuásia",
          "PHP": "Peso filipino",
          "PKR": "Rupia paquistanesa",
          "PLN": "Zloty polonês",
          "PLZ": "Zloti polonês (1950–1995)",
          "PTE": "Escudo português",
          "PYG": "Guarani paraguaio",
          "QAR": "Rial catariano",
          "RHD": "Dólar rodesiano",
          "ROL": "Leu romeno (1952–2006)",
          "RON": "Leu romeno",
          "RSD": "Dinar sérvio",
          "RUB": "Rublo russo",
          "RUR": "Rublo russo (1991–1998)",
          "RWF": "Franco ruandês",
          "SAR": "Riyal saudita",
          "SBD": "Dólar das Ilhas Salomão",
          "SCR": "Rupia seichelense",
          "SDD": "Dinar sudanês (1992–2007)",
          "SDG": "Libra sudanesa",
          "SDP": "Libra sudanesa (1957–1998)",
          "SEK": "Coroa sueca",
          "SGD": "Dólar singapuriano",
          "SHP": "Libra de Santa Helena",
          "SIT": "Tolar Bons esloveno",
          "SKK": "Coroa eslovaca",
          "SLL": "Leone de Serra Leoa",
          "SOS": "Xelim somali",
          "SRD": "Dólar surinamês",
          "SRG": "Florim do Suriname",
          "SSP": "Libra sul-sudanesa",
          "STD": "Dobra de São Tomé e Príncipe (1977–2017)",
          "STN": "Dobra de São Tomé e Príncipe",
          "SUR": "Rublo soviético",
          "SVC": "Colom salvadorenho",
          "SYP": "Libra síria",
          "SZL": "Lilangeni suazi",
          "THB": "Baht tailandês",
          "TJR": "Rublo do Tadjiquistão",
          "TJS": "Somoni tadjique",
          "TMM": "Manat do Turcomenistão (1993–2009)",
          "TMT": "Manat turcomeno",
          "TND": "Dinar tunisiano",
          "TOP": "Paʻanga tonganesa",
          "TPE": "Escudo timorense",
          "TRL": "Lira turca (1922–2005)",
          "TRY": "Lira turca",
          "TTD": "Dólar de Trinidad e Tobago",
          "TWD": "Novo dólar taiwanês",
          "TZS": "Xelim tanzaniano",
          "UAH": "Hryvnia ucraniano",
          "UAK": "Karbovanetz ucraniano",
          "UGS": "Xelim ugandense (1966–1987)",
          "UGX": "Xelim ugandense",
          "USD": "Dólar americano",
          "USN": "Dólar norte-americano (Dia seguinte)",
          "USS": "Dólar norte-americano (Mesmo dia)",
          "UYI": "Peso uruguaio en unidades indexadas",
          "UYP": "Peso uruguaio (1975–1993)",
          "UYU": "Peso uruguaio",
          "UZS": "Som uzbeque",
          "VEB": "Bolívar venezuelano (1871–2008)",
          "VEF": "Bolívar venezuelano (2008–2018)",
          "VES": "Bolívar venezuelano",
          "VND": "Dong vietnamita",
          "VNN": "Dong vietnamita (1978–1985)",
          "VUV": "Vatu de Vanuatu",
          "WST": "Tala samoano",
          "XAF": "Franco CFA de BEAC",
          "XAG": "Prata",
          "XAU": "Ouro",
          "XBA": "Unidade Composta Europeia",
          "XBB": "Unidade Monetária Europeia",
          "XBC": "Unidade de Conta Europeia (XBC)",
          "XBD": "Unidade de Conta Europeia (XBD)",
          "XCD": "Dólar do Caribe Oriental",
          "XDR": "Direitos Especiais de Giro",
          "XEU": "Unidade de Moeda Europeia",
          "XFO": "Franco-ouro francês",
          "XFU": "Franco UIC francês",
          "XOF": "Franco CFA de BCEAO",
          "XPD": "Paládio",
          "XPF": "Franco CFP",
          "XPT": "Platina",
          "XRE": "Fundos RINET",
          "XTS": "Código de Moeda de Teste",
          "XXX": "Moeda desconhecida",
          "YDD": "Dinar iemenita",
          "YER": "Rial iemenita",
          "YUD": "Dinar forte iugoslavo (1966–1990)",
          "YUM": "Dinar noviy iugoslavo (1994–2002)",
          "YUN": "Dinar conversível iugoslavo (1990–1992)",
          "YUR": "Dinar reformado iugoslavo (1992–1993)",
          "ZAL": "Rand sul-africano (financeiro)",
          "ZAR": "Rand sul-africano",
          "ZMK": "Cuacha zambiano (1968–2012)",
          "ZMW": "Kwacha zambiano",
          "ZRN": "Zaire Novo zairense (1993–1998)",
          "ZRZ": "Zaire zairense (1971–1993)",
          "ZWD": "Dólar do Zimbábue (1980–2008)",
          "ZWL": "Dólar do Zimbábue (2009)",
          "ZWR": "Dólar do Zimbábue (2008)"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "dia",
          "dayOfYear": "dia do ano",
          "dayperiod": "AM/PM",
          "era": "era",
          "hour": "hora",
          "minute": "minuto",
          "month": "mês",
          "quarter": "trimestre",
          "second": "segundo",
          "timeZoneName": "fuso horário",
          "weekOfMonth": "semana do mês",
          "weekOfYear": "semana",
          "weekday": "dia da semana",
          "weekdayOfMonth": "dia da semana do mês",
          "year": "ano"
        },
        "narrow": {
          "day": "dia",
          "dayOfYear": "dia do ano",
          "dayperiod": "AM/PM",
          "era": "era",
          "hour": "h",
          "minute": "min.",
          "month": "mês",
          "quarter": "trim.",
          "second": "seg.",
          "timeZoneName": "fuso",
          "weekOfMonth": "sem. do mês",
          "weekOfYear": "sem.",
          "weekday": "dia da sem.",
          "weekdayOfMonth": "dia da sem. do mês",
          "year": "ano"
        },
        "short": {
          "day": "dia",
          "dayOfYear": "dia do ano",
          "dayperiod": "AM/PM",
          "era": "era",
          "hour": "h",
          "minute": "min.",
          "month": "mês",
          "quarter": "trim.",
          "second": "seg.",
          "timeZoneName": "fuso",
          "weekOfMonth": "sem. do mês",
          "weekOfYear": "sem.",
          "weekday": "dia da sem.",
          "weekdayOfMonth": "dia da sem. do mês",
          "year": "ano"
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "afar",
            "ab": "abcázio",
            "ace": "achém",
            "ach": "acoli",
            "ada": "adangme",
            "ady": "adigue",
            "ae": "avéstico",
            "af": "africâner",
            "afh": "afrihili",
            "agq": "aghem",
            "ain": "ainu",
            "ak": "akan",
            "akk": "acadiano",
            "ale": "aleúte",
            "alt": "altai meridional",
            "am": "amárico",
            "an": "aragonês",
            "ang": "inglês arcaico",
            "ann": "obolo",
            "anp": "angika",
            "ar": "árabe",
            "ar-001": "árabe moderno",
            "arc": "aramaico",
            "arn": "mapudungun",
            "arp": "arapaho",
            "ars": "árabe négede",
            "arw": "arauaqui",
            "as": "assamês",
            "asa": "asu",
            "ast": "asturiano",
            "atj": "atikamekw",
            "av": "avárico",
            "awa": "awadhi",
            "ay": "aimará",
            "az": "azerbaijano",
            "az-Arab": "azeri sul",
            "ba": "bashkir",
            "bal": "balúchi",
            "ban": "balinês",
            "bas": "basa",
            "bax": "bamum",
            "bbj": "ghomala’",
            "be": "bielorrusso",
            "bej": "beja",
            "bem": "bemba",
            "bez": "bena",
            "bfd": "bafut",
            "bg": "búlgaro",
            "bgn": "balúchi ocidental",
            "bho": "bhojpuri",
            "bi": "bislamá",
            "bik": "bikol",
            "bin": "bini",
            "bkm": "kom",
            "bla": "siksika",
            "bm": "bambara",
            "bn": "bengali",
            "bo": "tibetano",
            "br": "bretão",
            "bra": "braj",
            "brx": "bodo",
            "bs": "bósnio",
            "bss": "akoose",
            "bua": "buriato",
            "bug": "buginês",
            "bum": "bulu",
            "byn": "blin",
            "byv": "medumba",
            "ca": "catalão",
            "cad": "caddo",
            "car": "caribe",
            "cay": "cayuga",
            "cch": "atsam",
            "ccp": "chakma",
            "ce": "checheno",
            "ceb": "cebuano",
            "cgg": "chiga",
            "ch": "chamorro",
            "chb": "chibcha",
            "chg": "chagatai",
            "chk": "chuukese",
            "chm": "mari",
            "chn": "jargão Chinook",
            "cho": "choctaw",
            "chp": "chipewyan",
            "chr": "cheroqui",
            "chy": "cheiene",
            "ckb": "curdo central",
            "clc": "chilcotin",
            "co": "corso",
            "cop": "copta",
            "cr": "cree",
            "crg": "michif",
            "crh": "tártara da Crimeia",
            "crj": "cree do sudeste",
            "crk": "cree das planícies",
            "crl": "cree do nordeste",
            "crm": "moose cree",
            "crr": "algonquiano Carolina",
            "crs": "crioulo francês seichelense",
            "cs": "tcheco",
            "csb": "kashubian",
            "csw": "cree swampy",
            "cu": "eslavo eclesiástico",
            "cv": "tchuvache",
            "cy": "galês",
            "da": "dinamarquês",
            "dak": "dacota",
            "dar": "dargwa",
            "dav": "taita",
            "de": "alemão",
            "de-CH": "alto alemão (Suíça)",
            "del": "delaware",
            "den": "slave",
            "dgr": "dogrib",
            "din": "dinka",
            "dje": "zarma",
            "doi": "dogri",
            "dsb": "baixo sorábio",
            "dua": "duala",
            "dum": "holandês médio",
            "dv": "divehi",
            "dyo": "jola-fonyi",
            "dyu": "diúla",
            "dz": "dzonga",
            "dzg": "dazaga",
            "ebu": "embu",
            "ee": "ewe",
            "efi": "efique",
            "egy": "egípcio arcaico",
            "eka": "ekajuk",
            "el": "grego",
            "elx": "elamite",
            "en": "inglês",
            "enm": "inglês médio",
            "eo": "esperanto",
            "es": "espanhol",
            "et": "estoniano",
            "eu": "basco",
            "ewo": "ewondo",
            "fa": "persa",
            "fa-AF": "dari",
            "fan": "fangue",
            "fat": "fanti",
            "ff": "fula",
            "fi": "finlandês",
            "fil": "filipino",
            "fj": "fijiano",
            "fo": "feroês",
            "fon": "fom",
            "fr": "francês",
            "frc": "francês cajun",
            "frm": "francês médio",
            "fro": "francês arcaico",
            "frr": "frísio setentrional",
            "frs": "frisão oriental",
            "fur": "friulano",
            "fy": "frísio ocidental",
            "ga": "irlandês",
            "gaa": "ga",
            "gag": "gagauz",
            "gan": "gan",
            "gay": "gayo",
            "gba": "gbaia",
            "gd": "gaélico escocês",
            "gez": "geez",
            "gil": "gilbertês",
            "gl": "galego",
            "gmh": "alto alemão médio",
            "gn": "guarani",
            "goh": "alemão arcaico alto",
            "gon": "gondi",
            "gor": "gorontalo",
            "got": "gótico",
            "grb": "grebo",
            "grc": "grego arcaico",
            "gsw": "alemão (Suíça)",
            "gu": "guzerate",
            "guz": "gusii",
            "gv": "manx",
            "gwi": "gwichʼin",
            "ha": "hauçá",
            "hai": "haida",
            "hak": "hacá",
            "haw": "havaiano",
            "hax": "haida do sul",
            "he": "hebraico",
            "hi": "híndi",
            "hil": "hiligaynon",
            "hit": "hitita",
            "hmn": "hmong",
            "ho": "hiri motu",
            "hr": "croata",
            "hsb": "alto sorábio",
            "hsn": "xiang",
            "ht": "haitiano",
            "hu": "húngaro",
            "hup": "hupa",
            "hur": "halkomelem",
            "hy": "armênio",
            "hz": "herero",
            "ia": "interlíngua",
            "iba": "iban",
            "ibb": "ibibio",
            "id": "indonésio",
            "ie": "interlingue",
            "ig": "igbo",
            "ii": "sichuan yi",
            "ik": "inupiaque",
            "ikt": "inuktitut canadense ocidental",
            "ilo": "ilocano",
            "inh": "inguche",
            "io": "ido",
            "is": "islandês",
            "it": "italiano",
            "iu": "inuktitut",
            "ja": "japonês",
            "jbo": "lojban",
            "jgo": "nguemba",
            "jmc": "machame",
            "jpr": "judaico-persa",
            "jrb": "judaico-arábico",
            "jv": "javanês",
            "ka": "georgiano",
            "kaa": "kara-kalpak",
            "kab": "kabyle",
            "kac": "kachin",
            "kaj": "jju",
            "kam": "kamba",
            "kaw": "kawi",
            "kbd": "kabardiano",
            "kbl": "kanembu",
            "kcg": "tyap",
            "kde": "maconde",
            "kea": "crioulo cabo-verdiano",
            "kfo": "koro",
            "kg": "congolês",
            "kgp": "caingangue",
            "kha": "khasi",
            "kho": "khotanês",
            "khq": "koyra chiini",
            "ki": "quicuio",
            "kj": "cuanhama",
            "kk": "cazaque",
            "kkj": "kako",
            "kl": "groenlandês",
            "kln": "kalenjin",
            "km": "khmer",
            "kmb": "quimbundo",
            "kn": "canarim",
            "ko": "coreano",
            "koi": "komi-permyak",
            "kok": "concani",
            "kos": "kosraean",
            "kpe": "kpelle",
            "kr": "canúri",
            "krc": "karachay-balkar",
            "krl": "carélio",
            "kru": "kurukh",
            "ks": "caxemira",
            "ksb": "shambala",
            "ksf": "bafia",
            "ksh": "kölsch",
            "ku": "curdo",
            "kum": "kumyk",
            "kut": "kutenai",
            "kv": "komi",
            "kw": "córnico",
            "kwk": "kwakʼwala",
            "ky": "quirguiz",
            "la": "latim",
            "lad": "ladino",
            "lag": "langi",
            "lah": "lahnda",
            "lam": "lamba",
            "lb": "luxemburguês",
            "lez": "lezgui",
            "lg": "luganda",
            "li": "limburguês",
            "lil": "lillooet",
            "lkt": "lacota",
            "lmo": "lombardo",
            "ln": "lingala",
            "lo": "laosiano",
            "lol": "mongo",
            "lou": "crioulo da Louisiana",
            "loz": "lozi",
            "lrc": "luri setentrional",
            "lsm": "saamia",
            "lt": "lituano",
            "lu": "luba-catanga",
            "lua": "luba-lulua",
            "lui": "luiseno",
            "lun": "lunda",
            "luo": "luo",
            "lus": "lushai",
            "luy": "luyia",
            "lv": "letão",
            "mad": "madurês",
            "maf": "mafa",
            "mag": "magahi",
            "mai": "maithili",
            "mak": "makasar",
            "man": "mandinga",
            "mas": "massai",
            "mde": "maba",
            "mdf": "mocsa",
            "mdr": "mandar",
            "men": "mende",
            "mer": "meru",
            "mfe": "morisyen",
            "mg": "malgaxe",
            "mga": "irlandês médio",
            "mgh": "macua",
            "mgo": "meta’",
            "mh": "marshalês",
            "mi": "maori",
            "mic": "miquemaque",
            "min": "minangkabau",
            "mk": "macedônio",
            "ml": "malaiala",
            "mn": "mongol",
            "mnc": "manchu",
            "mni": "manipuri",
            "moe": "innu-aimun",
            "moh": "moicano",
            "mos": "mossi",
            "mr": "marati",
            "ms": "malaio",
            "mt": "maltês",
            "mua": "mundang",
            "mul": "múltiplos idiomas",
            "mus": "creek",
            "mwl": "mirandês",
            "mwr": "marwari",
            "my": "birmanês",
            "mye": "myene",
            "myv": "erzya",
            "mzn": "mazandarani",
            "na": "nauruano",
            "nan": "min nan",
            "nap": "napolitano",
            "naq": "nama",
            "nb": "bokmål norueguês",
            "nd": "ndebele do norte",
            "nds": "baixo alemão",
            "nds-NL": "baixo saxão",
            "ne": "nepalês",
            "new": "newari",
            "ng": "dongo",
            "nia": "nias",
            "niu": "niueano",
            "nl": "holandês",
            "nl-BE": "flamengo",
            "nmg": "kwasio",
            "nn": "nynorsk norueguês",
            "nnh": "ngiemboon",
            "no": "norueguês",
            "nog": "nogai",
            "non": "nórdico arcaico",
            "nqo": "n’ko",
            "nr": "ndebele do sul",
            "nso": "soto setentrional",
            "nus": "nuer",
            "nv": "navajo",
            "nwc": "newari clássico",
            "ny": "nianja",
            "nym": "nyamwezi",
            "nyn": "nyankole",
            "nyo": "nyoro",
            "nzi": "nzima",
            "oc": "occitânico",
            "oj": "ojibwa",
            "ojb": "ojibwa do noroeste",
            "ojc": "ojibwa central",
            "ojs": "oji-cree",
            "ojw": "ojibwa ocidental",
            "oka": "okanagan",
            "om": "oromo",
            "or": "oriá",
            "os": "osseto",
            "osa": "osage",
            "ota": "turco otomano",
            "pa": "panjabi",
            "pag": "pangasinã",
            "pal": "pálavi",
            "pam": "pampanga",
            "pap": "papiamento",
            "pau": "palauano",
            "pcm": "pidgin nigeriano",
            "peo": "persa arcaico",
            "phn": "fenício",
            "pi": "páli",
            "pis": "pijin",
            "pl": "polonês",
            "pon": "pohnpeiano",
            "pqm": "malecite–passamaquoddy",
            "prg": "prussiano",
            "pro": "provençal arcaico",
            "ps": "pashto",
            "pt": "português",
            "qu": "quíchua",
            "quc": "quiché",
            "raj": "rajastani",
            "rap": "rapanui",
            "rar": "rarotongano",
            "rhg": "ruainga",
            "rm": "romanche",
            "rn": "rundi",
            "ro": "romeno",
            "ro-MD": "moldávio",
            "rof": "rombo",
            "rom": "romani",
            "ru": "russo",
            "rup": "aromeno",
            "rw": "quiniaruanda",
            "rwk": "rwa",
            "sa": "sânscrito",
            "sad": "sandawe",
            "sah": "sakha",
            "sam": "aramaico samaritano",
            "saq": "samburu",
            "sas": "sasak",
            "sat": "santali",
            "sba": "ngambay",
            "sbp": "sangu",
            "sc": "sardo",
            "scn": "siciliano",
            "sco": "scots",
            "sd": "sindi",
            "sdh": "curdo meridional",
            "se": "sami setentrional",
            "see": "seneca",
            "seh": "sena",
            "sel": "selkup",
            "ses": "koyraboro senni",
            "sg": "sango",
            "sga": "irlandês arcaico",
            "sh": "servo-croata",
            "shi": "tachelhit",
            "shn": "shan",
            "shu": "árabe chadiano",
            "si": "cingalês",
            "sid": "sidamo",
            "sk": "eslovaco",
            "sl": "esloveno",
            "slh": "lushootseed do sul",
            "sm": "samoano",
            "sma": "sami meridional",
            "smj": "sami de Lule",
            "smn": "lapão de Inari",
            "sms": "sami de Skolt",
            "sn": "xona",
            "snk": "soninquê",
            "so": "somali",
            "sog": "sogdiano",
            "sq": "albanês",
            "sr": "sérvio",
            "srn": "surinamês",
            "srr": "serere",
            "ss": "suázi",
            "ssy": "saho",
            "st": "soto do sul",
            "str": "salish do estreito norte",
            "su": "sundanês",
            "suk": "sukuma",
            "sus": "susu",
            "sux": "sumério",
            "sv": "sueco",
            "sw": "suaíli",
            "sw-CD": "suaíli do Congo",
            "swb": "comoriano",
            "syc": "siríaco clássico",
            "syr": "siríaco",
            "ta": "tâmil",
            "tce": "tutchone do sul",
            "te": "télugo",
            "tem": "timne",
            "teo": "teso",
            "ter": "tereno",
            "tet": "tétum",
            "tg": "tadjique",
            "tgx": "tagish",
            "th": "tailandês",
            "tht": "tahltan",
            "ti": "tigrínia",
            "tig": "tigré",
            "tiv": "tiv",
            "tk": "turcomeno",
            "tkl": "toquelauano",
            "tl": "tagalo",
            "tlh": "klingon",
            "tli": "tlinguite",
            "tmh": "tamaxeque",
            "tn": "tswana",
            "to": "tonganês",
            "tog": "tonganês de Nyasa",
            "tok": "toki pona",
            "tpi": "tok pisin",
            "tr": "turco",
            "trv": "taroko",
            "ts": "tsonga",
            "tsi": "tsimshiano",
            "tt": "tártaro",
            "ttm": "tutchone setentrional",
            "tum": "tumbuka",
            "tvl": "tuvaluano",
            "tw": "twi",
            "twq": "tasawaq",
            "ty": "taitiano",
            "tyv": "tuviniano",
            "tzm": "tamazight do Atlas Central",
            "udm": "udmurte",
            "ug": "uigur",
            "uga": "ugarítico",
            "uk": "ucraniano",
            "umb": "umbundu",
            "und": "idioma desconhecido",
            "ur": "urdu",
            "uz": "uzbeque",
            "vai": "vai",
            "ve": "venda",
            "vi": "vietnamita",
            "vo": "volapuque",
            "vot": "vótico",
            "vun": "vunjo",
            "wa": "valão",
            "wae": "walser",
            "wal": "wolaytta",
            "war": "waray",
            "was": "washo",
            "wbp": "warlpiri",
            "wo": "uolofe",
            "wuu": "wu",
            "xal": "kalmyk",
            "xh": "xhosa",
            "xog": "lusoga",
            "yao": "yao",
            "yap": "yapese",
            "yav": "yangben",
            "ybb": "yemba",
            "yi": "iídiche",
            "yo": "iorubá",
            "yrl": "nheengatu",
            "yue": "cantonês",
            "za": "zhuang",
            "zap": "zapoteco",
            "zbl": "símbolos blis",
            "zen": "zenaga",
            "zgh": "tamazirte marroqino padrão",
            "zh": "chinês",
            "zh-Hans": "chinês simplificado",
            "zh-Hant": "chinês tradicional",
            "zu": "zulu",
            "zun": "zunhi",
            "zxx": "sem conteúdo linguístico",
            "zza": "zazaki"
          },
          "narrow": {
          },
          "short": {
            "az": "azerbaijano",
            "en-US": "inglês (EUA)"
          }
        },
        "standard": {
          "long": {
            "aa": "afar",
            "ab": "abcázio",
            "ace": "achém",
            "ach": "acoli",
            "ada": "adangme",
            "ady": "adigue",
            "ae": "avéstico",
            "af": "africâner",
            "afh": "afrihili",
            "agq": "aghem",
            "ain": "ainu",
            "ak": "akan",
            "akk": "acadiano",
            "ale": "aleúte",
            "alt": "altai meridional",
            "am": "amárico",
            "an": "aragonês",
            "ang": "inglês arcaico",
            "ann": "obolo",
            "anp": "angika",
            "ar": "árabe",
            "ar-001": "árabe (Mundo)",
            "arc": "aramaico",
            "arn": "mapudungun",
            "arp": "arapaho",
            "ars": "árabe négede",
            "arw": "arauaqui",
            "as": "assamês",
            "asa": "asu",
            "ast": "asturiano",
            "atj": "atikamekw",
            "av": "avárico",
            "awa": "awadhi",
            "ay": "aimará",
            "az": "azerbaijano",
            "az-Arab": "azeri sul",
            "ba": "bashkir",
            "bal": "balúchi",
            "ban": "balinês",
            "bas": "basa",
            "bax": "bamum",
            "bbj": "ghomala’",
            "be": "bielorrusso",
            "bej": "beja",
            "bem": "bemba",
            "bez": "bena",
            "bfd": "bafut",
            "bg": "búlgaro",
            "bgn": "balúchi ocidental",
            "bho": "bhojpuri",
            "bi": "bislamá",
            "bik": "bikol",
            "bin": "bini",
            "bkm": "kom",
            "bla": "siksika",
            "bm": "bambara",
            "bn": "bengali",
            "bo": "tibetano",
            "br": "bretão",
            "bra": "braj",
            "brx": "bodo",
            "bs": "bósnio",
            "bss": "akoose",
            "bua": "buriato",
            "bug": "buginês",
            "bum": "bulu",
            "byn": "blin",
            "byv": "medumba",
            "ca": "catalão",
            "cad": "caddo",
            "car": "caribe",
            "cay": "cayuga",
            "cch": "atsam",
            "ccp": "chakma",
            "ce": "checheno",
            "ceb": "cebuano",
            "cgg": "chiga",
            "ch": "chamorro",
            "chb": "chibcha",
            "chg": "chagatai",
            "chk": "chuukese",
            "chm": "mari",
            "chn": "jargão Chinook",
            "cho": "choctaw",
            "chp": "chipewyan",
            "chr": "cheroqui",
            "chy": "cheiene",
            "ckb": "curdo central",
            "clc": "chilcotin",
            "co": "corso",
            "cop": "copta",
            "cr": "cree",
            "crg": "michif",
            "crh": "tártara da Crimeia",
            "crj": "cree do sudeste",
            "crk": "cree das planícies",
            "crl": "cree do nordeste",
            "crm": "moose cree",
            "crr": "algonquiano Carolina",
            "crs": "crioulo francês seichelense",
            "cs": "tcheco",
            "csb": "kashubian",
            "csw": "cree swampy",
            "cu": "eslavo eclesiástico",
            "cv": "tchuvache",
            "cy": "galês",
            "da": "dinamarquês",
            "dak": "dacota",
            "dar": "dargwa",
            "dav": "taita",
            "de": "alemão",
            "de-CH": "alemão (Suíça)",
            "del": "delaware",
            "den": "slave",
            "dgr": "dogrib",
            "din": "dinka",
            "dje": "zarma",
            "doi": "dogri",
            "dsb": "baixo sorábio",
            "dua": "duala",
            "dum": "holandês médio",
            "dv": "divehi",
            "dyo": "jola-fonyi",
            "dyu": "diúla",
            "dz": "dzonga",
            "dzg": "dazaga",
            "ebu": "embu",
            "ee": "ewe",
            "efi": "efique",
            "egy": "egípcio arcaico",
            "eka": "ekajuk",
            "el": "grego",
            "elx": "elamite",
            "en": "inglês",
            "enm": "inglês médio",
            "eo": "esperanto",
            "es": "espanhol",
            "et": "estoniano",
            "eu": "basco",
            "ewo": "ewondo",
            "fa": "persa",
            "fa-AF": "persa (Afeganistão)",
            "fan": "fangue",
            "fat": "fanti",
            "ff": "fula",
            "fi": "finlandês",
            "fil": "filipino",
            "fj": "fijiano",
            "fo": "feroês",
            "fon": "fom",
            "fr": "francês",
            "frc": "francês cajun",
            "frm": "francês médio",
            "fro": "francês arcaico",
            "frr": "frísio setentrional",
            "frs": "frisão oriental",
            "fur": "friulano",
            "fy": "frísio ocidental",
            "ga": "irlandês",
            "gaa": "ga",
            "gag": "gagauz",
            "gan": "gan",
            "gay": "gayo",
            "gba": "gbaia",
            "gd": "gaélico escocês",
            "gez": "geez",
            "gil": "gilbertês",
            "gl": "galego",
            "gmh": "alto alemão médio",
            "gn": "guarani",
            "goh": "alemão arcaico alto",
            "gon": "gondi",
            "gor": "gorontalo",
            "got": "gótico",
            "grb": "grebo",
            "grc": "grego arcaico",
            "gsw": "alemão (Suíça)",
            "gu": "guzerate",
            "guz": "gusii",
            "gv": "manx",
            "gwi": "gwichʼin",
            "ha": "hauçá",
            "hai": "haida",
            "hak": "hacá",
            "haw": "havaiano",
            "hax": "haida do sul",
            "he": "hebraico",
            "hi": "híndi",
            "hil": "hiligaynon",
            "hit": "hitita",
            "hmn": "hmong",
            "ho": "hiri motu",
            "hr": "croata",
            "hsb": "alto sorábio",
            "hsn": "xiang",
            "ht": "haitiano",
            "hu": "húngaro",
            "hup": "hupa",
            "hur": "halkomelem",
            "hy": "armênio",
            "hz": "herero",
            "ia": "interlíngua",
            "iba": "iban",
            "ibb": "ibibio",
            "id": "indonésio",
            "ie": "interlingue",
            "ig": "igbo",
            "ii": "sichuan yi",
            "ik": "inupiaque",
            "ikt": "inuktitut canadense ocidental",
            "ilo": "ilocano",
            "inh": "inguche",
            "io": "ido",
            "is": "islandês",
            "it": "italiano",
            "iu": "inuktitut",
            "ja": "japonês",
            "jbo": "lojban",
            "jgo": "nguemba",
            "jmc": "machame",
            "jpr": "judaico-persa",
            "jrb": "judaico-arábico",
            "jv": "javanês",
            "ka": "georgiano",
            "kaa": "kara-kalpak",
            "kab": "kabyle",
            "kac": "kachin",
            "kaj": "jju",
            "kam": "kamba",
            "kaw": "kawi",
            "kbd": "kabardiano",
            "kbl": "kanembu",
            "kcg": "tyap",
            "kde": "maconde",
            "kea": "crioulo cabo-verdiano",
            "kfo": "koro",
            "kg": "congolês",
            "kgp": "caingangue",
            "kha": "khasi",
            "kho": "khotanês",
            "khq": "koyra chiini",
            "ki": "quicuio",
            "kj": "cuanhama",
            "kk": "cazaque",
            "kkj": "kako",
            "kl": "groenlandês",
            "kln": "kalenjin",
            "km": "khmer",
            "kmb": "quimbundo",
            "kn": "canarim",
            "ko": "coreano",
            "koi": "komi-permyak",
            "kok": "concani",
            "kos": "kosraean",
            "kpe": "kpelle",
            "kr": "canúri",
            "krc": "karachay-balkar",
            "krl": "carélio",
            "kru": "kurukh",
            "ks": "caxemira",
            "ksb": "shambala",
            "ksf": "bafia",
            "ksh": "kölsch",
            "ku": "curdo",
            "kum": "kumyk",
            "kut": "kutenai",
            "kv": "komi",
            "kw": "córnico",
            "kwk": "kwakʼwala",
            "ky": "quirguiz",
            "la": "latim",
            "lad": "ladino",
            "lag": "langi",
            "lah": "lahnda",
            "lam": "lamba",
            "lb": "luxemburguês",
            "lez": "lezgui",
            "lg": "luganda",
            "li": "limburguês",
            "lil": "lillooet",
            "lkt": "lacota",
            "lmo": "lombardo",
            "ln": "lingala",
            "lo": "laosiano",
            "lol": "mongo",
            "lou": "crioulo da Louisiana",
            "loz": "lozi",
            "lrc": "luri setentrional",
            "lsm": "saamia",
            "lt": "lituano",
            "lu": "luba-catanga",
            "lua": "luba-lulua",
            "lui": "luiseno",
            "lun": "lunda",
            "luo": "luo",
            "lus": "lushai",
            "luy": "luyia",
            "lv": "letão",
            "mad": "madurês",
            "maf": "mafa",
            "mag": "magahi",
            "mai": "maithili",
            "mak": "makasar",
            "man": "mandinga",
            "mas": "massai",
            "mde": "maba",
            "mdf": "mocsa",
            "mdr": "mandar",
            "men": "mende",
            "mer": "meru",
            "mfe": "morisyen",
            "mg": "malgaxe",
            "mga": "irlandês médio",
            "mgh": "macua",
            "mgo": "meta’",
            "mh": "marshalês",
            "mi": "maori",
            "mic": "miquemaque",
            "min": "minangkabau",
            "mk": "macedônio",
            "ml": "malaiala",
            "mn": "mongol",
            "mnc": "manchu",
            "mni": "manipuri",
            "moe": "innu-aimun",
            "moh": "moicano",
            "mos": "mossi",
            "mr": "marati",
            "ms": "malaio",
            "mt": "maltês",
            "mua": "mundang",
            "mul": "múltiplos idiomas",
            "mus": "creek",
            "mwl": "mirandês",
            "mwr": "marwari",
            "my": "birmanês",
            "mye": "myene",
            "myv": "erzya",
            "mzn": "mazandarani",
            "na": "nauruano",
            "nan": "min nan",
            "nap": "napolitano",
            "naq": "nama",
            "nb": "bokmål norueguês",
            "nd": "ndebele do norte",
            "nds": "baixo alemão",
            "nds-NL": "baixo alemão (Países Baixos)",
            "ne": "nepalês",
            "new": "newari",
            "ng": "dongo",
            "nia": "nias",
            "niu": "niueano",
            "nl": "holandês",
            "nl-BE": "holandês (Bélgica)",
            "nmg": "kwasio",
            "nn": "nynorsk norueguês",
            "nnh": "ngiemboon",
            "no": "norueguês",
            "nog": "nogai",
            "non": "nórdico arcaico",
            "nqo": "n’ko",
            "nr": "ndebele do sul",
            "nso": "soto setentrional",
            "nus": "nuer",
            "nv": "navajo",
            "nwc": "newari clássico",
            "ny": "nianja",
            "nym": "nyamwezi",
            "nyn": "nyankole",
            "nyo": "nyoro",
            "nzi": "nzima",
            "oc": "occitânico",
            "oj": "ojibwa",
            "ojb": "ojibwa do noroeste",
            "ojc": "ojibwa central",
            "ojs": "oji-cree",
            "ojw": "ojibwa ocidental",
            "oka": "okanagan",
            "om": "oromo",
            "or": "oriá",
            "os": "osseto",
            "osa": "osage",
            "ota": "turco otomano",
            "pa": "panjabi",
            "pag": "pangasinã",
            "pal": "pálavi",
            "pam": "pampanga",
            "pap": "papiamento",
            "pau": "palauano",
            "pcm": "pidgin nigeriano",
            "peo": "persa arcaico",
            "phn": "fenício",
            "pi": "páli",
            "pis": "pijin",
            "pl": "polonês",
            "pon": "pohnpeiano",
            "pqm": "malecite–passamaquoddy",
            "prg": "prussiano",
            "pro": "provençal arcaico",
            "ps": "pashto",
            "pt": "português",
            "qu": "quíchua",
            "quc": "quiché",
            "raj": "rajastani",
            "rap": "rapanui",
            "rar": "rarotongano",
            "rhg": "ruainga",
            "rm": "romanche",
            "rn": "rundi",
            "ro": "romeno",
            "ro-MD": "romeno (Moldávia)",
            "rof": "rombo",
            "rom": "romani",
            "ru": "russo",
            "rup": "aromeno",
            "rw": "quiniaruanda",
            "rwk": "rwa",
            "sa": "sânscrito",
            "sad": "sandawe",
            "sah": "sakha",
            "sam": "aramaico samaritano",
            "saq": "samburu",
            "sas": "sasak",
            "sat": "santali",
            "sba": "ngambay",
            "sbp": "sangu",
            "sc": "sardo",
            "scn": "siciliano",
            "sco": "scots",
            "sd": "sindi",
            "sdh": "curdo meridional",
            "se": "sami setentrional",
            "see": "seneca",
            "seh": "sena",
            "sel": "selkup",
            "ses": "koyraboro senni",
            "sg": "sango",
            "sga": "irlandês arcaico",
            "sh": "servo-croata",
            "shi": "tachelhit",
            "shn": "shan",
            "shu": "árabe chadiano",
            "si": "cingalês",
            "sid": "sidamo",
            "sk": "eslovaco",
            "sl": "esloveno",
            "slh": "lushootseed do sul",
            "sm": "samoano",
            "sma": "sami meridional",
            "smj": "sami de Lule",
            "smn": "lapão de Inari",
            "sms": "sami de Skolt",
            "sn": "xona",
            "snk": "soninquê",
            "so": "somali",
            "sog": "sogdiano",
            "sq": "albanês",
            "sr": "sérvio",
            "srn": "surinamês",
            "srr": "serere",
            "ss": "suázi",
            "ssy": "saho",
            "st": "soto do sul",
            "str": "salish do estreito norte",
            "su": "sundanês",
            "suk": "sukuma",
            "sus": "susu",
            "sux": "sumério",
            "sv": "sueco",
            "sw": "suaíli",
            "sw-CD": "suaíli (Congo - Kinshasa)",
            "swb": "comoriano",
            "syc": "siríaco clássico",
            "syr": "siríaco",
            "ta": "tâmil",
            "tce": "tutchone do sul",
            "te": "télugo",
            "tem": "timne",
            "teo": "teso",
            "ter": "tereno",
            "tet": "tétum",
            "tg": "tadjique",
            "tgx": "tagish",
            "th": "tailandês",
            "tht": "tahltan",
            "ti": "tigrínia",
            "tig": "tigré",
            "tiv": "tiv",
            "tk": "turcomeno",
            "tkl": "toquelauano",
            "tl": "tagalo",
            "tlh": "klingon",
            "tli": "tlinguite",
            "tmh": "tamaxeque",
            "tn": "tswana",
            "to": "tonganês",
            "tog": "tonganês de Nyasa",
            "tok": "toki pona",
            "tpi": "tok pisin",
            "tr": "turco",
            "trv": "taroko",
            "ts": "tsonga",
            "tsi": "tsimshiano",
            "tt": "tártaro",
            "ttm": "tutchone setentrional",
            "tum": "tumbuka",
            "tvl": "tuvaluano",
            "tw": "twi",
            "twq": "tasawaq",
            "ty": "taitiano",
            "tyv": "tuviniano",
            "tzm": "tamazight do Atlas Central",
            "udm": "udmurte",
            "ug": "uigur",
            "uga": "ugarítico",
            "uk": "ucraniano",
            "umb": "umbundu",
            "und": "idioma desconhecido",
            "ur": "urdu",
            "uz": "uzbeque",
            "vai": "vai",
            "ve": "venda",
            "vi": "vietnamita",
            "vo": "volapuque",
            "vot": "vótico",
            "vun": "vunjo",
            "wa": "valão",
            "wae": "walser",
            "wal": "wolaytta",
            "war": "waray",
            "was": "washo",
            "wbp": "warlpiri",
            "wo": "uolofe",
            "wuu": "wu",
            "xal": "kalmyk",
            "xh": "xhosa",
            "xog": "lusoga",
            "yao": "yao",
            "yap": "yapese",
            "yav": "yangben",
            "ybb": "yemba",
            "yi": "iídiche",
            "yo": "iorubá",
            "yrl": "nheengatu",
            "yue": "cantonês",
            "za": "zhuang",
            "zap": "zapoteco",
            "zbl": "símbolos blis",
            "zen": "zenaga",
            "zgh": "tamazirte marroqino padrão",
            "zh": "chinês",
            "zh-Hans": "chinês simplificado",
            "zh-Hant": "chinês tradicional",
            "zu": "zulu",
            "zun": "zunhi",
            "zxx": "sem conteúdo linguístico",
            "zza": "zazaki"
          },
          "narrow": {
          },
          "short": {
            "az": "azerbaijano",
            "en-US": "inglês (EUA)"
          }
        }
      },
      "region": {
        "long": {
          "001": "Mundo",
          "002": "África",
          "003": "América do Norte",
          "005": "América do Sul",
          "009": "Oceania",
          "011": "África Ocidental",
          "013": "América Central",
          "014": "África Oriental",
          "015": "África do Norte",
          "017": "África Central",
          "018": "África Meridional",
          "019": "Américas",
          "021": "América Setentrional",
          "029": "Caribe",
          "030": "Ásia Oriental",
          "034": "Ásia Meridional",
          "035": "Sudeste Asiático",
          "039": "Europa Meridional",
          "053": "Australásia",
          "054": "Melanésia",
          "057": "Região da Micronésia",
          "061": "Polinésia",
          "142": "Ásia",
          "143": "Ásia Central",
          "145": "Ásia Ocidental",
          "150": "Europa",
          "151": "Europa Oriental",
          "154": "Europa Setentrional",
          "155": "Europa Ocidental",
          "202": "África Subsaariana",
          "419": "América Latina",
          "AC": "Ilha de Ascensão",
          "AD": "Andorra",
          "AE": "Emirados Árabes Unidos",
          "AF": "Afeganistão",
          "AG": "Antígua e Barbuda",
          "AI": "Anguila",
          "AL": "Albânia",
          "AM": "Armênia",
          "AO": "Angola",
          "AQ": "Antártida",
          "AR": "Argentina",
          "AS": "Samoa Americana",
          "AT": "Áustria",
          "AU": "Austrália",
          "AW": "Aruba",
          "AX": "Ilhas Aland",
          "AZ": "Azerbaijão",
          "BA": "Bósnia e Herzegovina",
          "BB": "Barbados",
          "BD": "Bangladesh",
          "BE": "Bélgica",
          "BF": "Burquina Faso",
          "BG": "Bulgária",
          "BH": "Barein",
          "BI": "Burundi",
          "BJ": "Benin",
          "BL": "São Bartolomeu",
          "BM": "Bermudas",
          "BN": "Brunei",
          "BO": "Bolívia",
          "BQ": "Países Baixos Caribenhos",
          "BR": "Brasil",
          "BS": "Bahamas",
          "BT": "Butão",
          "BV": "Ilha Bouvet",
          "BW": "Botsuana",
          "BY": "Bielorrússia",
          "BZ": "Belize",
          "CA": "Canadá",
          "CC": "Ilhas Cocos (Keeling)",
          "CD": "Congo - Kinshasa",
          "CF": "República Centro-Africana",
          "CG": "República do Congo",
          "CH": "Suíça",
          "CI": "Costa do Marfim",
          "CK": "Ilhas Cook",
          "CL": "Chile",
          "CM": "Camarões",
          "CN": "China",
          "CO": "Colômbia",
          "CP": "Ilha de Clipperton",
          "CR": "Costa Rica",
          "CU": "Cuba",
          "CV": "Cabo Verde",
          "CW": "Curaçao",
          "CX": "Ilha Christmas",
          "CY": "Chipre",
          "CZ": "Tchéquia",
          "DE": "Alemanha",
          "DG": "Diego Garcia",
          "DJ": "Djibuti",
          "DK": "Dinamarca",
          "DM": "Dominica",
          "DO": "República Dominicana",
          "DZ": "Argélia",
          "EA": "Ceuta e Melilla",
          "EC": "Equador",
          "EE": "Estônia",
          "EG": "Egito",
          "EH": "Saara Ocidental",
          "ER": "Eritreia",
          "ES": "Espanha",
          "ET": "Etiópia",
          "EU": "União Europeia",
          "EZ": "zona do euro",
          "FI": "Finlândia",
          "FJ": "Fiji",
          "FK": "Ilhas Malvinas",
          "FM": "Micronésia",
          "FO": "Ilhas Faroé",
          "FR": "França",
          "GA": "Gabão",
          "GB": "Reino Unido",
          "GD": "Granada",
          "GE": "Geórgia",
          "GF": "Guiana Francesa",
          "GG": "Guernsey",
          "GH": "Gana",
          "GI": "Gibraltar",
          "GL": "Groenlândia",
          "GM": "Gâmbia",
          "GN": "Guiné",
          "GP": "Guadalupe",
          "GQ": "Guiné Equatorial",
          "GR": "Grécia",
          "GS": "Ilhas Geórgia do Sul e Sandwich do Sul",
          "GT": "Guatemala",
          "GU": "Guam",
          "GW": "Guiné-Bissau",
          "GY": "Guiana",
          "HK": "Hong Kong, RAE da China",
          "HM": "Ilhas Heard e McDonald",
          "HN": "Honduras",
          "HR": "Croácia",
          "HT": "Haiti",
          "HU": "Hungria",
          "IC": "Ilhas Canárias",
          "ID": "Indonésia",
          "IE": "Irlanda",
          "IL": "Israel",
          "IM": "Ilha de Man",
          "IN": "Índia",
          "IO": "Território Britânico do Oceano Índico",
          "IQ": "Iraque",
          "IR": "Irã",
          "IS": "Islândia",
          "IT": "Itália",
          "JE": "Jersey",
          "JM": "Jamaica",
          "JO": "Jordânia",
          "JP": "Japão",
          "KE": "Quênia",
          "KG": "Quirguistão",
          "KH": "Camboja",
          "KI": "Quiribati",
          "KM": "Comores",
          "KN": "São Cristóvão e Névis",
          "KP": "Coreia do Norte",
          "KR": "Coreia do Sul",
          "KW": "Kuwait",
          "KY": "Ilhas Cayman",
          "KZ": "Cazaquistão",
          "LA": "Laos",
          "LB": "Líbano",
          "LC": "Santa Lúcia",
          "LI": "Liechtenstein",
          "LK": "Sri Lanka",
          "LR": "Libéria",
          "LS": "Lesoto",
          "LT": "Lituânia",
          "LU": "Luxemburgo",
          "LV": "Letônia",
          "LY": "Líbia",
          "MA": "Marrocos",
          "MC": "Mônaco",
          "MD": "Moldávia",
          "ME": "Montenegro",
          "MF": "São Martinho",
          "MG": "Madagascar",
          "MH": "Ilhas Marshall",
          "MK": "Macedônia do Norte",
          "ML": "Mali",
          "MM": "Mianmar (Birmânia)",
          "MN": "Mongólia",
          "MO": "Macau, RAE da China",
          "MP": "Ilhas Marianas do Norte",
          "MQ": "Martinica",
          "MR": "Mauritânia",
          "MS": "Montserrat",
          "MT": "Malta",
          "MU": "Maurício",
          "MV": "Maldivas",
          "MW": "Malaui",
          "MX": "México",
          "MY": "Malásia",
          "MZ": "Moçambique",
          "NA": "Namíbia",
          "NC": "Nova Caledônia",
          "NE": "Níger",
          "NF": "Ilha Norfolk",
          "NG": "Nigéria",
          "NI": "Nicarágua",
          "NL": "Países Baixos",
          "NO": "Noruega",
          "NP": "Nepal",
          "NR": "Nauru",
          "NU": "Niue",
          "NZ": "Nova Zelândia",
          "OM": "Omã",
          "PA": "Panamá",
          "PE": "Peru",
          "PF": "Polinésia Francesa",
          "PG": "Papua-Nova Guiné",
          "PH": "Filipinas",
          "PK": "Paquistão",
          "PL": "Polônia",
          "PM": "São Pedro e Miquelão",
          "PN": "Ilhas Pitcairn",
          "PR": "Porto Rico",
          "PS": "Territórios palestinos",
          "PT": "Portugal",
          "PW": "Palau",
          "PY": "Paraguai",
          "QA": "Catar",
          "QO": "Oceania Remota",
          "RE": "Reunião",
          "RO": "Romênia",
          "RS": "Sérvia",
          "RU": "Rússia",
          "RW": "Ruanda",
          "SA": "Arábia Saudita",
          "SB": "Ilhas Salomão",
          "SC": "Seicheles",
          "SD": "Sudão",
          "SE": "Suécia",
          "SG": "Singapura",
          "SH": "Santa Helena",
          "SI": "Eslovênia",
          "SJ": "Svalbard e Jan Mayen",
          "SK": "Eslováquia",
          "SL": "Serra Leoa",
          "SM": "San Marino",
          "SN": "Senegal",
          "SO": "Somália",
          "SR": "Suriname",
          "SS": "Sudão do Sul",
          "ST": "São Tomé e Príncipe",
          "SV": "El Salvador",
          "SX": "Sint Maarten",
          "SY": "Síria",
          "SZ": "Essuatíni",
          "TA": "Tristão da Cunha",
          "TC": "Ilhas Turcas e Caicos",
          "TD": "Chade",
          "TF": "Territórios Franceses do Sul",
          "TG": "Togo",
          "TH": "Tailândia",
          "TJ": "Tadjiquistão",
          "TK": "Tokelau",
          "TL": "Timor-Leste",
          "TM": "Turcomenistão",
          "TN": "Tunísia",
          "TO": "Tonga",
          "TR": "Turquia",
          "TT": "Trinidad e Tobago",
          "TV": "Tuvalu",
          "TW": "Taiwan",
          "TZ": "Tanzânia",
          "UA": "Ucrânia",
          "UG": "Uganda",
          "UM": "Ilhas Menores Distantes dos EUA",
          "UN": "Nações Unidas",
          "US": "Estados Unidos",
          "UY": "Uruguai",
          "UZ": "Uzbequistão",
          "VA": "Cidade do Vaticano",
          "VC": "São Vicente e Granadinas",
          "VE": "Venezuela",
          "VG": "Ilhas Virgens Britânicas",
          "VI": "Ilhas Virgens Americanas",
          "VN": "Vietnã",
          "VU": "Vanuatu",
          "WF": "Wallis e Futuna",
          "WS": "Samoa",
          "XA": "Pseudossotaques",
          "XB": "Pseudobidirecional",
          "XK": "Kosovo",
          "YE": "Iêmen",
          "YT": "Mayotte",
          "ZA": "África do Sul",
          "ZM": "Zâmbia",
          "ZW": "Zimbábue",
          "ZZ": "Região desconhecida"
        },
        "narrow": {
        },
        "short": {
          "GB": "Reino Unido",
          "HK": "Hong Kong",
          "MO": "Macau",
          "PS": "Palestina",
          "UN": "ONU",
          "US": "EUA"
        }
      },
      "script": {
        "long": {
          "Adlm": "adlam",
          "Arab": "árabe",
          "Aran": "nastaliq",
          "Armi": "armi",
          "Armn": "armênio",
          "Avst": "avéstico",
          "Bali": "balinês",
          "Bamu": "bamum",
          "Batk": "bataque",
          "Beng": "bengali",
          "Blis": "símbolos bliss",
          "Bopo": "bopomofo",
          "Brah": "brahmi",
          "Brai": "braille",
          "Bugi": "buginês",
          "Buhd": "buhid",
          "Cakm": "cakm",
          "Cans": "escrita silábica unificada dos aborígenes canadenses",
          "Cari": "cariano",
          "Cham": "cham",
          "Cher": "cherokee",
          "Cirt": "cirth",
          "Copt": "cóptico",
          "Cprt": "cipriota",
          "Cyrl": "cirílico",
          "Cyrs": "cirílico eslavo eclesiástico",
          "Deva": "devanágari",
          "Dsrt": "deseret",
          "Egyd": "demótico egípcio",
          "Egyh": "hierático egípcio",
          "Egyp": "hieróglifos egípcios",
          "Ethi": "etiópico",
          "Geok": "khutsuri georgiano",
          "Geor": "georgiano",
          "Glag": "glagolítico",
          "Goth": "gótico",
          "Grek": "grego",
          "Gujr": "guzerate",
          "Guru": "gurmuqui",
          "Hanb": "hanb",
          "Hang": "hangul",
          "Hani": "han",
          "Hano": "hanunoo",
          "Hans": "simplificado",
          "Hant": "tradicional",
          "Hebr": "hebraico",
          "Hira": "hiragana",
          "Hmng": "pahawh hmong",
          "Hrkt": "silabários japoneses",
          "Hung": "húngaro antigo",
          "Inds": "indo",
          "Ital": "itálico antigo",
          "Jamo": "jamo",
          "Java": "javanês",
          "Jpan": "japonês",
          "Kali": "kayah li",
          "Kana": "katakana",
          "Khar": "kharoshthi",
          "Khmr": "khmer",
          "Knda": "kannada",
          "Kore": "coreano",
          "Kthi": "kthi",
          "Lana": "lanna",
          "Laoo": "lao",
          "Latf": "latim fraktur",
          "Latg": "latim gaélico",
          "Latn": "latim",
          "Lepc": "lepcha",
          "Limb": "limbu",
          "Lina": "linear A",
          "Linb": "linear B",
          "Lisu": "lisu",
          "Lyci": "lício",
          "Lydi": "lídio",
          "Mand": "mandaico",
          "Mani": "maniqueano",
          "Maya": "hieróglifos maias",
          "Merc": "meroítico cursivo",
          "Mero": "meroítico",
          "Mlym": "malaiala",
          "Mong": "mongol",
          "Moon": "moon",
          "Mtei": "meitei mayek",
          "Mymr": "birmanês",
          "Nkoo": "n’ko",
          "Ogam": "ogâmico",
          "Olck": "ol chiki",
          "Orkh": "orkhon",
          "Orya": "oriá",
          "Osma": "osmania",
          "Perm": "pérmico antigo",
          "Phag": "phags-pa",
          "Phli": "phli",
          "Phlp": "phlp",
          "Phlv": "pahlavi antigo",
          "Phnx": "fenício",
          "Plrd": "fonético pollard",
          "Prti": "prti",
          "Qaag": "zawgyi",
          "Rjng": "rejang",
          "Rohg": "hanifi",
          "Roro": "rongorongo",
          "Runr": "rúnico",
          "Samr": "samaritano",
          "Sara": "sarati",
          "Saur": "saurashtra",
          "Sgnw": "signwriting",
          "Shaw": "shaviano",
          "Sinh": "cingalês",
          "Sund": "sundanês",
          "Sylo": "syloti nagri",
          "Syrc": "siríaco",
          "Syre": "siríaco estrangelo",
          "Syrj": "siríaco ocidental",
          "Syrn": "siríaco oriental",
          "Tagb": "tagbanwa",
          "Tale": "tai Le",
          "Talu": "novo tai lue",
          "Taml": "tâmil",
          "Tavt": "tavt",
          "Telu": "télugo",
          "Teng": "tengwar",
          "Tfng": "tifinagh",
          "Tglg": "tagalo",
          "Thaa": "thaana",
          "Thai": "tailandês",
          "Tibt": "tibetano",
          "Ugar": "ugarítico",
          "Vaii": "vai",
          "Visp": "visible speech",
          "Xpeo": "persa antigo",
          "Xsux": "sumério-acadiano cuneiforme",
          "Yiii": "yi",
          "Zinh": "herdado",
          "Zmth": "notação matemática",
          "Zsye": "emoji",
          "Zsym": "zsym",
          "Zxxx": "ágrafo",
          "Zyyy": "comum",
          "Zzzz": "escrita desconhecida"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "pt"
})
}